// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as OrderRequestsActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import PurchasesPasts from '../components/PurchasesPasts/PurchasesPasts';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    isFetchingPasts: state.orders.isFetchingPasts,
    pastPurchases: state.orders.pastPurchases,
    page: state.orders.pastPurchasesPage,
    canAsk: state.orders.pastPurchasesPageCanAsk,
    fetchPastError: state.orders.fetchPastError,
    localeState: state.locale,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...OrderRequestsActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PurchasesPasts);



// WEBPACK FOOTER //
// ./src/modules/orders/containers/PurchasesPastsContainer.js